import { render, staticRenderFns } from "./Artigos.vue?vue&type=template&id=0f136c62&scoped=true&"
import script from "./Artigos.vue?vue&type=script&lang=js&"
export * from "./Artigos.vue?vue&type=script&lang=js&"
import style0 from "./Artigos.vue?vue&type=style&index=0&id=0f136c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f136c62",
  null
  
)

export default component.exports